import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Codice promo {{code}} applicato',
  [COUPON_TYPES.CASHBACK]: 'Punti fedeltà applicati',
  [COUPON_TYPES.REWARD]: 'Premio applicato',
  [COUPON_TYPES.GIFT_CARD]: 'Gift card applicata',
};

export default Coupons;
